import { createActions, handleActions } from 'redux-actions'

// helpers
import { startSubmitting } from './_helpers'

export const GENERATE_UIF_DECLARATION_FILE = 'uif/GENERATE_UIF_DECLARATION_FILE'
export const GENERATE_UIF_DECLARATION_FILE_FAILURE = 'uif/GENERATE_UIF_DECLARATION_FILE_FAILURE'
export const GENERATE_UIF_DECLARATION_FILE_SUCCESS = 'uif/GENERATE_UIF_DECLARATION_FILE_SUCCESS'

export const {
  uif: {
    generateUifDeclarationFile,
    generateUifDeclarationFileSuccess,
    generateUifDeclarationFileFailure
  }
} = createActions({
  [GENERATE_UIF_DECLARATION_FILE]: undefined,
  [GENERATE_UIF_DECLARATION_FILE_FAILURE]: undefined,
  [GENERATE_UIF_DECLARATION_FILE_SUCCESS]: undefined
})

const initialState = {
  errorMessage: null,
  hasError: false,
  isLoading: false,
  isSubmitting: false,
  isSuccess: null
}

export default handleActions(
  {
    [GENERATE_UIF_DECLARATION_FILE]: startSubmitting,
    [GENERATE_UIF_DECLARATION_FILE_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message || 'An unknown error occurred',
      isLoading: false,
      isSubmitting: false,
      isSuccess: false,
      hasError: true
    }),
    [GENERATE_UIF_DECLARATION_FILE_SUCCESS]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: false,
      hasSubmitted: true,
      isSuccess: true,
      hasError: false
    })
  },
  initialState
)
